import type { ReactNode } from 'react';
import { InfoTip } from './InfoTip';

// One titled step block on the Viewer page, shown when its tab is active. A
// centered title tops the step; the children render that step's tooling. When
// `info` is given (the matching "MVP Notes" entry), a circled "i" next to the
// title reveals that text on hover/focus.
export function EtapeSection({
  title,
  info,
  children,
}: {
  title: string;
  info?: string;
  children?: ReactNode;
}) {
  return (
    <section className="pt-2">
      <div className="mb-4 flex items-center justify-center gap-2">
        <h2 className="font-sora text-center text-xl font-bold tracking-tight text-white">
          {title}
        </h2>
        {info && <InfoTip text={info} />}
      </div>
      {/* Spacing under the title, separating it from the phase content — no rule drawn
          here any more, the blueprint page shows through the gap instead. The div stays
          because the gap was always its margin; only the border is gone. */}
      <div className="mb-6" />
      {children}
      {/* Closing spacing, so every phase ends with the same gap by construction. */}
      <div className="mt-6" />
    </section>
  );
}
